import Text from 'components/Text/Text';
import React, { useCallback, useContext, useEffect, useState } from 'react';
import { Input } from 'antd';
import { IWordingsItem } from 'types';
import { IWordingsContext, WordingsContext } from '../../../../wordingsState/wordingsContext';
import classNames from 'classnames';
import breadcrumbs from 'assets/img/breadcrumbs.svg';
import style from './LocalizationItem.module.scss';

interface ILocalizationItem {
	groupId: string;
	itemData: IWordingsItem;
	languageId: string;
	isRequired?: boolean;
}

export const LocalizationItem: React.FC<ILocalizationItem> = ({ groupId, itemData, languageId, isRequired }) => {
	const { setDeleteWordingData, changeTypeOfModalWindow, invalidFields } =
		useContext<IWordingsContext>(WordingsContext);
	const [localValue, setLocalValue] = useState<string | undefined>(undefined);
	const [isTouched, setIsTouched] = useState<boolean>(false);
	const [error, setError] = useState<boolean>(false);

	const errorClasses = classNames(style.error, { [style.errorVisible]: error && !localValue && isRequired });

	const translationData = itemData.translations.find((el) => el.languageId === languageId);
	const fieldName = `${groupId}/${itemData.key}/${languageId}/${isRequired}`;

	useEffect(() => {
		if (!localValue && isTouched && isRequired) {
			setError(true);
		}
	}, [isTouched, localValue, isRequired]);

	useEffect(() => {
		if (invalidFields.some((el) => el === fieldName)) {
			setError(true);
		}
	}, [invalidFields, fieldName]);

	useEffect(() => {
		if (translationData?.value) {
			setLocalValue(translationData?.value);
		}
	}, [translationData?.value]);

	const handleInput = () => {
		setError(false);
		setIsTouched(true);
	};

	const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		setLocalValue(e.target.value);
	};

	const handleDeleteWording = useCallback(() => {
		if (itemData.id) {
			setDeleteWordingData({
				groupId: groupId,
				wordingId: itemData.id,
			});
			changeTypeOfModalWindow('toConfirmDeleteItem');
		}
	}, [groupId, itemData.id]);

	return (
		<div className={style.container}>
			<Text
				className={style.fieldHeader}
				translationNameSpace="localizationSettings"
				translationKey={itemData.label}
				theme="neutralLight"
				size="xs"
			/>
			<div className={style.inputContainer}>
				<Input
					className={style.input}
					name={fieldName}
					value={localValue}
					disabled={true} // TODO remove when editing will be implemented on BE
					onInput={handleInput}
					onChange={handleChange}
					placeholder="Enter"
				/>
				<svg className={style.deleteIcon} onClick={handleDeleteWording}>
					<use xlinkHref={`${breadcrumbs}#crossMark`} />
				</svg>
			</div>
			<Text
				className={errorClasses}
				translationNameSpace="error"
				translationKey="enterValue"
				theme="error"
				size="xs"
			/>
		</div>
	);
};
